import React from 'react';

import type { FormSliderProps } from './FormSlider.types';

import { FormField } from '@/components/forms';
import { FilterRangeSlider } from '@/components/ui/Filter';

/**
 * Thin form wrapper around the design-system {@link FilterRangeSlider} (single
 * mode) — adds a label, help text, and error via {@link FormField} so a slider
 * reads like the other form fields. Used for the 1–10 `goal_priority` rating.
 *
 * `goal_priority` is optional: when `value` is `undefined` the track rests at the
 * midpoint and nothing is written until the user moves it.
 */
export function FormSlider({
  label,
  helpText,
  error,
  min,
  max,
  step = 1,
  value,
  onChange,
  unit,
}: FormSliderProps): React.JSX.Element {
  const display = value ?? Math.round((min + max) / 2);

  return (
    <FormField label={label} error={error} helpText={helpText}>
      <FilterRangeSlider
        value={display}
        min={min}
        max={max}
        step={step}
        unit={unit}
        ariaLabel={label}
        onChange={(next) => onChange(typeof next === 'number' ? next : next[1])}
      />
    </FormField>
  );
}

export default FormSlider;
